/* eslint-disable indent */
import { Select, Popover } from 'antd';
import React, { useState } from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';
import './_selectOption.scss';

/**
 * @param {import('antd').SelectProps} props
 */

const { Option } = Select;

export const SelectOption = (props) => {
  const [open, setOpen] = useState(false);
  const {
    dropdownRender,
    loading,
    onChange,
    options,
    placeholder,
    suffixIcon,
    value,
    disabled,
    allowClear = false,
  } = props;

  const popoverContent = (
    <div className='feature-mainmap-place container-popover'>
      <div className='arrow arrow---down' />
      <p className='feature-mainmap-place container-popover-text'>
        Contact our sales to subscribe
      </p>
    </div>
  );

  function compareStatus(a, b) {
    return a.disabled - b.disabled;
  }

  return (
    <Select
      allowClear={
        value && allowClear
          ? {
              clearIcon: <CloseCircleOutlined />,
            }
          : false
      }
      className='shared-selectOption'
      disabled={disabled}
      dropdownRender={dropdownRender}
      loading={loading}
      onChange={onChange}
      onDropdownVisibleChange={(e) => {
        setOpen(e);
      }}
      open={open}
      placeholder={placeholder}
      suffixIcon={suffixIcon}
      value={value}
    >
      {options?.sort(compareStatus).map((v) => (
        <Option disabled={v.disabled} key={v.value} value={v.value}>
          {v.disabled ? (
            <Popover
              content={!v?.withoutPopup ? popoverContent : null}
              overlayClassName='shared-selectOption'
              placement='topLeft'
            >
              {v.label}
            </Popover>
          ) : (
            v.label
          )}
        </Option>
      ))}
    </Select>
  );
};
